import { PanelCard } from '../../ui/PanelCard'

const Bar = ({ className = '' }: { className?: string }) => (
  <div className={`animate-pulse rounded-md bg-gis-track ${className}`} />
)

/**
 * Cold-load skeleton (V5 layout): mirrors the loaded dashboard's single list-card shell — same
 * grid row, same card chrome — so there's no load→loaded layout shift. Only the placeholder rows
 * differ. (The toolbar is page-level and static, so it needs no skeleton.)
 */
export function IssuesDashboardSkeleton() {
  return (
    <div className="grid min-h-0 flex-1 grid-rows-[minmax(0,1fr)] p-3">
      <PanelCard title="Issues List" subtitle="Loading…" fillBody className="min-h-0">
        <div className="space-y-2 p-3">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
            <Bar key={i} className="h-[50px] rounded-[12px]" />
          ))}
        </div>
      </PanelCard>
    </div>
  )
}
